import { render, staticRenderFns } from "./colorParamPicker.vue?vue&type=template&id=51b9106c&scoped=true&"
import script from "./colorParamPicker.vue?vue&type=script&lang=js&"
export * from "./colorParamPicker.vue?vue&type=script&lang=js&"
import style0 from "./colorParamPicker.vue?vue&type=style&index=0&id=51b9106c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b9106c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VColorPicker,VDivider,VExpandTransition,VHover,VIcon,VSheet})
